import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
    };
  }

  componentDidMount = () => {
    let url = "/api/traces/v1/program/summary";
    let group = [];
    let branch_id = [];
    this.state.user.principal_group.forEach((item, index) => {
      group.push(item.principal_code);
    });
    this.state.user.branch.forEach((item, index) => {
      branch_id.push(item.org_id);
    });

    let param = {
      group: group,
      branch: branch_id,
      source: "arman",
    };
    // let param = {
    //     org_id: this.state.user.org_id
    // }
    this.setState({ loading: true });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };
  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "PROGRAM NO",
          accessor: "program_number",
          filterable: true,
        },
        {
          Header: "REF NO",
          accessor: "ref_number",
          filterable: true,
        },
        {
          Header: "PROGRAM TYPE",
          accessor: "program_name",
          filterable: true,
        },
        {
          Header: "DESCRIPTION",
          accessor: "description",
          filterable: true,
        },
        {
          Header: "PRINCIPAL",
          accessor: "org_name",
          filterable: true,
        },
        {
          Header: "SUBMITTED DATE",
          accessor: "creation_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        // {
        //     Header: 'BUDGET TYPE',
        //     accessor: 'budget_type'
        // },
        {
          Header: "BUDGET",
          accessor: "budget",
          className: "text-right",
          // filterable: true,
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "AMOUNT_CLAIM_SUBMIT",
          accessor: "encumbrance",
          className: "text-right",
          // filterable: true,
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "AMOUNT_CLAIM_APPROVED",
          accessor: "actual",
          className: "text-right",
          // filterable: true,
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "TOTAL_AMOUNT_CLAIM",
          accessor: "total",
          className: "text-right",
          // filterable: true,
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "STATUS_APPROVAL",
          accessor: "status_approval",
          filterable: true,
        },
        {
          Header: "STATUS_ACTIVE",
          accessor: "status_active",
          filterable: true,
        },
        {
          Header: "",
          accessor: "program_id",
          Cell: (row) => (
            <span>
              <button
                className="btn btn-info btn-sm"
                onClick={() => {
                  this.goDetail(row);
                }}
              >
                View
              </button>
            </span>
          ),
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable;
    let filename =
      "program-summary-" + moment(new Date()).format("DDMMYYYYHHmmss");

    return (
      <ExcelFile
        filename={filename}
        fileExtension="xls"
        element={
          <button className="btn btn-success">
            <i className="fas fa-file-excel" />
            Export to Excel
          </button>
        }
      >
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="PROGRAM NO" value="program_number" />
          <ExcelColumn label="REF NO" value="ref_number" />
          <ExcelColumn label="PROGRAM TYPE" value="program_name" />
          <ExcelColumn label="DESCRIPTION" value="description" />
          <ExcelColumn label="PRINCIPAL" value="org_name" />
          <ExcelColumn label="SUBMITTED DATE" value="creation_date" />
          {/* <ExcelColumn label="Budget Type" value="budget_type" /> */}
          <ExcelColumn label="BUDGET" value="budget" />
          <ExcelColumn label="AMOUNT_CLAIM_SUBMIT" value="encumbrance" />
          <ExcelColumn label="AMOUNT_CLAIM_APPROVED" value="actual" />
          <ExcelColumn label="TOTAL_AMOUNT_CLAIM" value="total" />
          <ExcelColumn label="STATUS APPROVAL" value="status_approval" />
          <ExcelColumn label="STATUS_ACTIVE" value="status_active" />
        </ExcelSheet>
      </ExcelFile>
    );
  };

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/program/summary/" + row.program_id);
  };

  handleSearch = (e) => {
    let value = e.target.value.toLowerCase();
    let container = [];
    _.find(this.state.baseTable, function (o) {
      let desc = o.description.toLowerCase();
      if (desc.indexOf(value) >= 0) {
        container.push(o);
      }
    });
    container.map((item, index) => {
      item.formatted_start_date = moment(item.start_date).format("DD-MM-YYYY");
      item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
      return item;
    });
    this.setState({ dataTable: container, search: value });
  };

  handleChangeStatus = (e) => {
    let value = e.target.value;
    let url = "/api/traces/v1/program/summary?status=" + value;
    let group = [];
    let branch_id = [];
    this.state.user.principal_group.forEach((item, index) => {
      group.push(item.principal_code);
    });
    this.state.user.branch.forEach((item, index) => {
      branch_id.push(item.org_id);
    });

    let param = {
      group: group,
      branch: branch_id,
      source: "arman",
    };
    this.setState({ loading: true });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  badgeClass = (status) => {
    let className = "";
    if (status === "P") {
      className = "badge badge-info";
    } else if (status === "A") {
      className = "badge badge-success";
    } else if (status === "R") {
      className = "badge badge-danger";
    } else if (status === "S") {
      className = "badge badge-secondary";
    }
    console.log(className);
    return className;
  };

  mappingStatus = (status) => {
    let mappingStatus = "";
    if (status === "P") {
      mappingStatus = "PROPOSE";
    } else if (status === "A") {
      mappingStatus = "APPROVED";
    } else if (status === "R") {
      mappingStatus = "REJECT";
    } else if (status === "S") {
      mappingStatus = "ASSIGN";
    }
    console.log(mappingStatus);
    return mappingStatus;
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 float-left">
                        <div className="row">
                          <div className="col-lg-6">
                            <select
                              name=""
                              className="form-control"
                              onChange={this.handleChangeStatus.bind(this)}
                            >
                              <option value="">ALL</option>
                              <option value="propose">Propose</option>
                              <option value="app_princ">
                                Approved by Principal
                              </option>
                              <option value="val">Validated</option>
                              <option value="app_aam">Approved by AAM</option>
                              <option value="rej_aam">Rejected by AAM</option>
                              <option value="rej_princ">
                                Rejected by Principal
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 float-right">
                        <div className="row">
                          {/* <div className="col-lg-6">
                                                        <input type="text" className="form-control" onChange={ this.handleSearch.bind(this) } placeholder="Search Program..." value={ this.state.search } />
                                                    </div> */}
                          <div className="col-lg-6 float-right">
                            {/* <button className="btn btn-success"><i className="fas fa-file-excel" /></button> */}
                            {/* {this.exportToExcel()} */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Summary;
